/* Endless product list under the product page (elliz-endless-products section), 2026-10-19.

   Keeps the iPhone safe (see scripts/scroll-memory-check.py and the notes in infinity-scroll.js):
   - never builds a DOM document from the response (DOMParser documents leaked): the product cards are cut
     out of the response text between the two comment markers and inserted with insertAdjacentHTML
   - one request at a time, at most `data-max-batches` batches, then it stops for good
   - a failed request is retried at most twice, then the list simply ends (no hammering)
   - loads when the sentinel is within 1400px of the screen, so a quick flick cannot queue requests
   - products already visible elsewhere on the page (recommendation rows) are removed from the list */
(function () {
  'use strict';

  var root = document.querySelector('[data-ece]');
  if (!root || root.dataset.eceReady) return;
  root.dataset.eceReady = '1';

  var grid = root.querySelector('[data-ece-grid]');
  var sentinel = root.querySelector('[data-ece-sentinel]');
  var sectionId = root.dataset.sectionId;
  var pages = parseInt(root.dataset.pages, 10) || 1;
  var maxBatches = parseInt(root.dataset.maxBatches, 10) || 8;
  var lastPage = Math.min(pages, maxBatches);
  var current = 1;
  var loading = false;
  var failures = 0;
  var observer = null;

  var START = '<!--ECE-START-->';
  var END = '<!--ECE-END-->';

  /* Handles of every product link outside this list, plus the product being viewed. */
  function handlesElsewhere() {
    var seen = {};
    if (root.dataset.currentHandle) seen[root.dataset.currentHandle] = true;
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (root.contains(links[i])) continue;
      var m = links[i].getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) seen[decodeURIComponent(m[1])] = true;
    }
    return seen;
  }

  /* Remove cards whose product is already on the page or already in this list. */
  function dedupe() {
    var seen = handlesElsewhere();
    var items = grid.querySelectorAll('[data-ece-handle]');
    for (var i = 0; i < items.length; i++) {
      var h = items[i].getAttribute('data-ece-handle');
      if (seen[h]) {
        items[i].remove();
      } else {
        seen[h] = true;
      }
    }
  }

  function finish() {
    if (observer) observer.disconnect();
    observer = null;
    if (sentinel) sentinel.remove();
  }

  function pageUrl(n) {
    var u = new URL(window.location.href);
    u.searchParams.set('section_id', sectionId);
    u.searchParams.set('page', String(n));
    return u.toString();
  }

  function loadNext() {
    if (loading || current >= lastPage) return;
    loading = true;
    var next = current + 1;
    fetch(pageUrl(next), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var a = text.indexOf(START);
        var b = text.indexOf(END);
        if (a === -1 || b === -1 || b < a) throw new Error('markers missing');
        grid.insertAdjacentHTML('beforeend', text.slice(a + START.length, b));
        text = null;
        dedupe();
        current = next;
        failures = 0;
        loading = false;
        if (current >= lastPage) {
          finish();
        } else if (observer) {
          /* the sentinel may still be inside the margin (short batch): re-evaluate so the next one loads */
          observer.unobserve(sentinel);
          observer.observe(sentinel);
        }
      })
      .catch(function () {
        failures += 1;
        loading = false;
        if (failures > 2) finish();
      });
  }

  dedupe();
  if (current >= lastPage) { finish(); return; }

  if (!('IntersectionObserver' in window)) { finish(); return; }
  observer = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) { loadNext(); break; }
    }
  }, { rootMargin: '0px 0px 1400px 0px' });
  observer.observe(sentinel);
})();
